import { formatDate, dateFormatForAPI } from '../utils/date';
import { matchBookingItems } from '../utils/booking';
import {
  formatBookingItems,
  formatRecurrencePayload,
  RecurrencePayload,
} from './formatBasketPayload';
import { RecurrenceOptions } from './recurrenceRuleBuilder';

interface BookingItemPayload {
  id?: number;
  date: string;
  startTime: string;
  endTime: string;
  spaceId: number;
}

interface UpdateBookingPayload {
  date: string;
  purchaseOrder?: string;
  bookingHostId?: number;
  bookingItems?: BookingItemPayload[];
  clientServiceId?: number;
  recurrence?: RecurrencePayload;
}

interface Slot {
  startTime: string;
  endTime: string;
}

interface BookingItems {
  [date: string]: { [space: string]: Slot[] };
}

interface FormatUpdateBookingOptions {
  date: string;
  bookingHostId?: number;
  clientServiceId?: number;
  recurrence?: RecurrenceOptions;
  bookingItems?: BookingItems;
  initialBookingItems?: BookingItems;
  purchaseOrder?: string;
}

export const formatUpdateBookingPayload = ({
  date,
  bookingHostId,
  clientServiceId,
  bookingItems,
  initialBookingItems,
  recurrence,
  purchaseOrder,
}: FormatUpdateBookingOptions): UpdateBookingPayload => ({
  date: formatDate(date, dateFormatForAPI),
  clientServiceId,
  ...(recurrence ? { recurrence: formatRecurrencePayload(recurrence) } : {}),
  ...(bookingHostId ? { bookingHostId } : {}),
  ...(bookingItems && Object.keys(bookingItems).length > 0
    ? {
        bookingItems: matchBookingItems(
          formatBookingItems(bookingItems),
          formatBookingItems(initialBookingItems)
        ),
      }
    : {}),
  ...(purchaseOrder ? { purchaseOrder } : {}),
});
